import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

interface Tab {
  hash: string;
  label: string;
}
export const useTabs = (tabs: Tab[], updateHash = true) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const tabsRef = useRef<HTMLDivElement>(null);
  const isTabClickRef = useRef(false);
  useEffect(() => {
    if (!updateHash) {
      return;
    }
    if (location.hash) {
      const tab = tabs.find(
        (tab) => tab.hash === location.hash.replace(/^\/|^#/, '')
      );
      if (tab) {
        setActiveTab(tabs.indexOf(tab));
      }
    }
  }, [location.hash, tabs, updateHash]);

  // react-router doesn't scroll to hashes, so bring the tabs into view.
  // keyed on location.key so re-clicking a link to the current hash still scrolls
  useEffect(() => {
    if (isTabClickRef.current) {
      isTabClickRef.current = false;
      return;
    }
    if (updateHash && location.hash) {
      tabsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [location.key, location.hash, updateHash]);

  const onTabsChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    if (updateHash) {
      isTabClickRef.current = true;
      navigate(
        {
          pathname: location.pathname,
          search: location.search,
          hash: tabs[newValue]!.hash,
        },
        { preventScrollReset: true }
      );
    }
  };
  return { tabs, activeTab, onTabsChange, tabsRef };
};
